import script from "./CommonMenuAside.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonMenuAside.vue?vue&type=script&setup=true&lang=js"

import "./CommonMenuAside.vue?vue&type=style&index=0&id=4aa4982c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa4982c"]])

export default __exports__